import React from "react";
import { Facebook, Instagram, Linkedin, Twitter } from "../../assets/svg";


export const socialMediaIcons = [
    { icon: <Facebook />, name: "Facebook", link: "https://www.facebook.com/Zazmic.Inc/" },
    { icon: <Twitter />, name: "Twitter", link: "https://twitter.com/i/flow/login?redirect_after_login=%2Fzazmic" },
    { icon: <Linkedin />, name: "Linkedin", link: "https://www.linkedin.com/company/zazmic-inc/" },
    { icon: <Instagram />, name: "Instagram", link: "https://www.instagram.com/zazmic/" }
  ];